export const iconFontAwesomeAlphabetP = (
	<i className="fa-solid fa-p"></i>
);
